import React, { JSX } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useStorageKey } from './hooks/useStorage';
import createReturnUrl from './utilities/createReturnUrl';
import { useAuth } from './AuthProvider';

function ActiveRoute(): JSX.Element {
  const { isLoggedIn, isManualLogout } = useAuth();
  const isSignUpCompleted = useStorageKey<boolean>('isSignUpCompleted');
  const location = useLocation();

  if (!isLoggedIn) {
    if (location.pathname === '/sign-in') {
      return <Outlet />; // Prevents unnecessary return URL creation
    }
    const redirectUrl = isManualLogout ? '/sign-in' : createReturnUrl('/sign-in', location);
    return <Navigate to={redirectUrl} />;
  }

  if (isSignUpCompleted === false) {
    return <Navigate to="/sign-up" />;
  }

  return <Outlet />; // render the child routes if sign-up is not completed
}

export default ActiveRoute;
